import { publicEnv } from '~/features/environment/public';
import { getWoolfUserQuery, WoolfUser, woolfUserSchema } from '~/features/woolf/models/woolf-user';
import { queryUdacityService } from '~/utils/query-udacity-service';

// Get the user's Woolf data.
// @param testCookieHeader - The test cookies to pass in when testing getServerSideProps
// @returns The user's Woolf data, or null if the user is not in Woolf
export async function getWoolfUser(jwt: string, userId: string, testCookieHeader?: string): Promise<WoolfUser | null> {
  const gqlResponse = await queryUdacityService({
    url: publicEnv.NEXT_PUBLIC_WOOLF_INTEGRATION_URL,
    zodSchema: woolfUserSchema,
    authorization: `Bearer ${jwt}`,
    body: JSON.stringify({
      query: getWoolfUserQuery,
      variables: { udacityId: userId },
    }),
    testCookieHeader,
  });

  // In the website context, archived and disabled users are not considered to be in Woolf.
  if (gqlResponse?.syncState === 'ARCHIVED' || gqlResponse?.syncState === 'DISABLED') {
    return null;
  }

  return gqlResponse;
}
